"use client";

import React from "react";
import type { TextareaHTMLAttributes } from "react";
import LabelInput from "../../label";
import * as S from "./styles";

type Validation = {
  type: "error" | "success" | "warning";
  message: string;
};

type TextareaInputProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  validation?: Validation;
  hasShadow?: boolean;
  labelDescription?: string;
};

const TextareaInput = React.forwardRef<HTMLTextAreaElement, TextareaInputProps>(
  (
    {
      className,
      placeholder,
      label,
      validation,
      disabled,
      labelDescription,
      hasShadow = false,
      ...rest
    },
    ref,
  ) => {
    return (
      <>
        {label && (
          <LabelInput labelInput={label} labelDescription={labelDescription} />
        )}

        <S.TextareaComponent
          ref={ref}
          className={className}
          placeholder={placeholder}
          $hasShadow={hasShadow}
          validation={validation}
          disabled={!!disabled}
          {...rest}
        />

        {validation?.type === "error" && (
          <S.ErrorMessage>{validation.message}</S.ErrorMessage>
        )}
      </>
    );
  },
);

TextareaInput.displayName = "TextareaInput";
export default TextareaInput;
